// extracted by mini-css-extract-plugin
export default {"fileName":"ModalUploadWorkLogAttachment_fileName__OFjjU"};